
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Row, Col, ButtonToolbar, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav, NavItem, NavLink } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import LoadingIcon from 'mdi-react/LoadingIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import DatePicker from '../../components/custom/DatePicker';
import NaviBar from '../../components/custom/NaviBar';
import DropdownField from '../../components/custom/DropdownField';
import AutoCompleteField from '../../components/custom/AutoCompleteField';
import RintagiScreen from '../../components/custom/Screen';
import ModalDialog from '../../components/custom/ModalDialog';
import { showNotification } from '../../redux/Notification';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation'
import { isEmptyId, getAddDtlPath, getAddMstPath, getEditDtlPath, getEditMstPath, getNaviPath, getDefaultPath } from '../../helpers/utils'
import { toMoney, toLocalAmountFormat, toLocalDateFormat, toDate, strFormat } from '../../helpers/formatter';
import { setTitle, setSpinner, setTopbarMenu, hideTopbarMenu, hideSidebar, registerTopbarLeft, registerTopbarCenter, registerTopbarRight } from '../../redux/Global';
import { RememberCurrent, GetCurrent } from '../../redux/Persist'
import { getNaviBar } from './index';
import SubTestReduxObj from '../../redux/SubTest';
import Skeleton from 'react-skeleton-loader';
import ControlledPopover from '../../components/custom/ControlledPopover';
import log from '../../helpers/logger';
import { loadPage, submitPlan } from '../../redux/Plan';
import VwRUsrSubDtlReduxObj, { ShowMstFilterApplied } from '../../redux/VwRUsrSubDtl';
import RBtnTrackingReduxObj from '../../redux/RBtnTracking';
import { getUrlBeforeRouter } from "../../helpers/formatter";
import { isEmpty, isNotEmpty } from '../../helpers/utils';
import ReactDOM from 'react-dom';
import { loadStripe } from '@stripe/stripe-js';


class Upgrade extends RintagiScreen {
  constructor(props) {
    super(props);
    this.GetReduxState = () => (this.props.VwRUsrSubDtl || {});
    this.blocker = null;
    this.titleSet = false;
    this.MstKeyColumnName = 'UsrSubsId4';
    this.SystemName = 'Rintagi';
    this.confirmUnload = this.confirmUnload.bind(this);
    this.hasChangedContent = false;
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.AutoCompleteFilterBy = (option, props) => { return true };
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.mobileView = window.matchMedia('(max-width: 1200px)');
    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.props.setSpinner(true);

    this.props.registerTopbarLeft("","",true,"","");
    this.props.hideSidebar(false);
    this.props.hideTopbarMenu(false);
   
    // this.props.registerTopbarCenter(this.props.history.location.pathname, true, 'Select a Plan');
    // this.props.registerTopbarRight(this.Close.bind(this), this.props.history.location.pathname, true, 'close');

    Promise.all([
      this.props.loadPage(),
    ]).catch(error => {

    }).finally(() => {
      setTimeout(() => this.props.setSpinner(false), 500);
    })

    // this.props.setTopbarMenu(true);

    this.state = {
      ScreenButton: null,
      initialing: true,
      Buttons: {},
      currentPlan: {
        // paymentMethod: ''
      },
      key: Date.now(),
      ModalColor: "",
      ModalTitle: "",
      ModalHeader: false,
      ModalMsg: '',
      ModalOpen: false,
      ModalSuccess: null,
      submitting: false,
      isMobile: false,
    }

     Promise.all([
      this.props.LoadPage('MstRecord', { mstId: '!' }),
    ]).catch(error => {
      
    }).finally(() => {
      // this.setState({ reduxRefreshed: true });
      setTimeout(() => this.props.setSpinner(false), 500);
      
    })

    if (!this.props.suppressLoadPage && this.props.history) {
      RememberCurrent('LastAppUrl', (this.props.history || {}).location, true);
    }

    if (!this.props.suppressLoadPage) {
      this.props.setSpinner(true);
    }
  }

  Close() {
    this.props.history.push('/dashboard');
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }
  

  subUsrId2InputChange() { const _this = this; return function (name, v) { const filterBy = ''; _this.props.SearchsubUsrId2(v, filterBy); } }/* ReactRule: Master Record Custom Function */
  /* ReactRule End: Master Record Custom Function */

  /* react related stuff */
  static getDerivedStateFromProps(nextProps, prevState) {
    const nextReduxScreenState = nextProps.SubTest || {};
    const buttons = nextReduxScreenState.Buttons || {};
    const revisedButtonDef = super.GetScreenButtonDef(buttons, 'Mst', prevState);
    const currentKey = nextReduxScreenState.key;
    const waiting = nextReduxScreenState.page_saving || nextReduxScreenState.page_loading;
    let revisedState = {};
    if (revisedButtonDef) revisedState.Buttons = revisedButtonDef;

    if (prevState.submitting && !waiting && nextReduxScreenState.submittedOn > prevState.submittedOn) {
      prevState.setSubmitting(false);
    }

    return revisedState;
  }

  confirmUnload(message, callback) {
    const SubTestState = this.props.SubTest || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalColor: 'warning', ModalTitle: auxSystemLabels.UnsavedPageTitle || '', ModalMsg: message });
  }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  ValidatePage(values) {
    const errors = {};

    log.debug('sync state', values)

    this.IsFormSubmit = false; // this is used by field validator and needs to be reset when we are here   
    this.FormGroup = undefined; // this is used by field validator and needs to be reset when we are here   

    return errors;
  }

  SubmitPlan = (values, { setSubmitting }) => {
    this.IsFormSubmit = false;
    this.setState({ submittedOn: Date.now(), submitting: true, setSubmitting: setSubmitting });

    this.props.setSpinner(true);

    const planUser = (this.props.user || {}).UsrId;

    log.debug(this.FormAction);

    this.props.submitPlan({
      planUser: planUser,
      planName: 'P',
      planPeriod: 'month',
      planPrice: '975',
      planCurrency: 'USD',
    });
    // .then(() => {
    //   this.setState({ key: Date.now() })
    // });

    this.FormAction = undefined;
  }

  componentDidMount() {
    this.mediaqueryresponse(this.mobileView);
    this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    const suppressLoadPage = this.props.suppressLoadPage;
    if (!suppressLoadPage) {
      const { mstId } = { ...this.props.match.params };
      // if (!(this.props.SubTest || {}).AuthCol || true) {
      //   this.props.LoadPage('Mst', { mstId: mstId || '_' });
      // }
      if (!(this.props.RBtnTracking || {}).AuthCol || true) {
        this.props.LoadPage('SearchList', { mstId: '!' });
      }   
      if (!(this.props.VwRUsrSubDtl || {}).AuthCol || true) {
        this.props.LoadUserPage('SearchList', { mstId: '!' });
        this.props.LoadUserInitPage({ keyId: null });
      }
    }
    else {
      return;
    }
  }

  componentDidUpdate(prevProps, prevStates) {
    const currReduxScreenState = this.props.VwRUsrSubDtl || {};

    if (!this.props.suppressLoadPage) {
      if (!currReduxScreenState.page_loading && this.props.global.pageSpinner) {
        const _this = this;
        setTimeout(() => _this.props.setSpinner(false), 500);
      }
    }

    const currMst = currReduxScreenState.Mst || {};
    this.SetPageTitle(currReduxScreenState);
    if (prevStates.key !== currMst.key) {
      if ((prevStates.ScreenButton || {}).buttonType === 'SaveClose') {
        const currDtl = currReduxScreenState.EditDtl || {};
        const dtlList = (currReduxScreenState.DtlList || {}).data || [];
        const naviBar = getNaviBar('Mst', currMst, currDtl, currReduxScreenState.Label);
        const searchListPath = getDefaultPath(getNaviPath(naviBar, 'MstList', '/'))
        this.props.history.push(searchListPath);
      }
    }

    const currentReduxObj = this.props.plan || {};
    const previousReduxObj = prevProps.plan || {};
    const currentPayment = (currentReduxObj.currentPayment || {});
    const previousPayment = (previousReduxObj.currentPayment || {});

    // if (!currentReduxObj.loading && !trustProfileReduxObj.loading && !contactsReduxObj.loading && !this.state.submitting && this.props.global.pageSpinner && !this.redirecting) {
    //   const _this = this;
    //   setTimeout(() => _this.props.setSpinner(false), 500);
    // }
    if (this.state.submitting &&
      !(currentReduxObj.loading) &&
      ((previousReduxObj.key !== currentReduxObj.key) || currentReduxObj.status === "failed")
    ) {

      log.debug('##### 1');

      this.state.setSubmitting(false);
      if (currentReduxObj.status !== "failed") {
        log.debug('##### 2');
        this.redirecting = true; // Control redirection
        setTimeout(() => {
          if (this.redirecting) {
            log.debug('##### 3');
            // this.props.history.push('/payment');
            setTimeout(() => { this.props.setSpinner(false) }, 0);
          }
          else {
            this.props.setSpinner(false);
          }
        }, 0);
      }
      else {
        this.setState({ submitting: false });
        this.props.setSpinner(false);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    this.mobileView.removeListener(this.mediaqueryresponse);
  }

  SubmitForm = (type) => {
    log.debug('type', type);
    const currMst = ((this.props.RBtnTracking || {}).Mst || {});
    log.debug('currMst', currMst);

    this.setState({ key: currMst.key });
    this.props.SavePage(
        this.props.RBtnTracking,
        {
          BtnTrackingId13: currMst.BtnTrackingId13|| '',
          UsrId13: currMst.UsrId13 || ((this.props.VwRUsrSubDtl || {}).Mst || {}).UsrId4 || '',
          DnldClickAmt13: currMst.DnldClickAmt13 || '',
          ProfClickAmt13: type === 'Professional' ? ((parseInt(currMst.ProfClickAmt13) + 1) || 1) : (currMst.ProfClickAmt13 || ''),
          EntClickAmt13: type === 'Enterprise' ? ((parseInt(currMst.EntClickAmt13) + 1) || 1) : (currMst.EntClickAmt13 || ''),
        },
        [],
        {
          persist: true,
          ScreenButton: null,
          OnClickColumeName: null,
        }
      );

      window.open('https://www.rintagi.com/contactus.aspx'); return false;
  }

  handleClick = async (event) => {   
    const location = window.location;
    const localhost = location.port >= 3000 && location.port <= 3100;
    const prdOnly = getUrlBeforeRouter().includes('rintagi.com') && location.protocol === "https:";
    const runtimeConfig = (document.Rintagi || {});
    log.debug(runtimeConfig);
    const stripePromise = loadStripe(runtimeConfig.stripeKey) ||  loadStripe('pk_test_f8cR5En7mRuX2lhQQAJaUO9x');
    const ProfessionalPrice = runtimeConfig.stripeProduct || 'plan_HGblSbjRI27KR2';

    const origin = location.origin;

    // When the customer clicks on the button, redirect them to Checkout.
    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      lineItems: [
        // Replace with the ID of your price
        //testing account
        //{price: 'plan_HGblSbjRI27KR2', quantity: 1}
        {price: ProfessionalPrice, quantity: 1}
      ],
      mode: 'subscription',
      successUrl: origin + (prdOnly ? '/react/sub' : '/rg/react/sub') + '/#/payment-confirmation',
      cancelUrl: origin  + (prdOnly ? '/react/sub' : '/rg/react/sub') + '/#/upgrade',
    });

    if(error){
      alert(error.message);
    }
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `error.message`.
  };


  render() {
    const notPassedOnboarding = isEmpty(((this.props.RSignUpSurvey || {}).Mst || {}).SignUpSurveyId12);
    if (notPassedOnboarding) {
      return <Redirect to='/' />;
    }

    const SubTestState = this.props.SubTest || {};

    if (SubTestState.access_denied) {
      return <Redirect to='/error' />;
    }

    const screenHlp = SubTestState.ScreenHlp;

    // Labels
    // const siteTitle = (this.props.global || {}).pageTitle || '';
    const siteTitle = 'Upgrade Options: Rintagi';
    log.debug(siteTitle);
    const MasterRecTitle = ((screenHlp || {}).MasterRecTitle || '');
    const MasterRecSubtitle = ((screenHlp || {}).MasterRecSubtitle || '');

    const screenButtons = SubTestReduxObj.GetScreenButtons(SubTestState) || {};
    const itemList = SubTestState.Dtl || [];
    const auxLabels = SubTestState.Label || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};

    const columnLabel = SubTestState.ColumnLabel || {};
    const authCol = this.GetAuthCol(SubTestState);
    const authRow = (SubTestState.AuthRow || [])[0] || {};
    const currMst = ((this.props.SubTest || {}).Mst || {});
    const currDtl = ((this.props.SubTest || {}).EditDtl || {});
    const naviBar = getNaviBar('Mst', currMst, currDtl, screenButtons).filter(v => ((v.type !== 'Dtl' && v.type !== 'DtlList') || currMst.subTestId2));
    const selectList = SubTestReduxObj.SearchListToSelectList(SubTestState);
    const selectedMst = (selectList || []).filter(v => v.isSelected)[0] || {};
    const subTestId2 = currMst.subTestId2;
    const subTestDesc2 = currMst.subTestDesc2;
    const subDate2 = currMst.subDate2;
    const subUsrId2List = SubTestReduxObj.ScreenDdlSelectors.subUsrId2(SubTestState);
    const subUsrId2 = currMst.subUsrId2;

    const { dropdownMenuButtonList, bottomButtonList, hasDropdownMenuButton, hasBottomButton, hasRowButton } = this.state.Buttons;
    const hasActableButtons = hasBottomButton || hasRowButton || hasDropdownMenuButton;

    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    /* ReactRule: Master Render */
    /* ReactRule End: Master Render */

    const reduxObj = this.props.plan || {};

    const plans = [
      {
        key: '4',
        labelShort: 'C',
        label: 'Community',
        value: '4',
        price: 'FREE',
        options: [
          { key: 1, option: 'Hosting: On-Premises or Self-Hosted Cloud', sidebar:'' },
          { key: 2, option: 'Development Environment', sidebar:'' }
        ],
      },
      {
        key: '5',
        labelShort: 'P',
        label: 'Professional',
        value: '5',
        price: '975',
        period: 'month, paid annually',
        options: [
          { key: 1, option: 'Hosting: On-Premises or Self-Hosted Cloud', sidebar:'' },
          { key: 2, option: ' Unlimited Environments', sidebar: '(DEV/SAT/UAT/PRD/etc.)' },
          { key: 3, option: 'Commercial License', sidebar:'' },
          { key: 4, option: 'Priority Rintagi Releases & Bug Fixes', sidebar:'' },
          { key: 5, option: 'Technical Support 8x5 ', sidebar:'(Phone and email support, PST working hours)' },
        ]
      },
      {
        key: '6',
        labelShort: 'E',
        label: 'Enterprise',
        value: '6',
        price: 'QUOTE',
        options: [
          { key: 1, option: 'Hosting: On-Premises or Self-Hosted Cloud', sidebar:'' },
          { key: 2, option: ' Unlimited Environments', sidebar:'(DEV/SAT/UAT/PRD/etc.)' },
          { key: 3, option: 'Commercial License', sidebar:'' },
          { key: 4, option: 'Priority Rintagi Releases & Bug Fixes', sidebar:'' },
          { key: 5, option: 'Technical Support 8x5 (24/7 Available)', sidebar:'(Phone and email support, PST working hours)' },
          { key: 6, option: 'Dedicated Account Manager', sidebar:'' },
        ]
      },
    ]

    const userPlanId = ((this.props.VwRUsrSubDtl || {}).Mst || {}).ProductId4;

    return (
      <DocumentTitle title={siteTitle}>
        <div>
          <ModalDialog color={this.state.ModalColor} title={this.state.ModalTitle} onChange={this.OnModalReturn} ModalOpen={this.state.ModalOpen} message={this.state.ModalMsg} />
          <div className='account'>
            <div className='account__wrapper account-full-width'>
              <div className='account__card'>
                <Formik
                  initialValues={this.state.currentPlan}
                  key={this.state.key}
                  validateOnChange={true}
                  validateOnBlur={true}
                  onSubmit={this.SubmitPlan}
                  render={({
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    dirty,
                    setFieldValue,
                    setFieldTouched,
                    handleChange,
                    submitForm,
                    setFieldError,
                  }) => (
                      <div>
                        <Form className='form'>
                          <div className='w-100'>
                            <h4 className='account__subhead subhead text-center mb-30'>Choose the perfect plan to suit your business needs.</h4>
                            <Row className="row-75">
                              {plans.map((obj, i) => (
                                <Col sm={12} md={4} className="mb-15 col-75" key={i}>
                                  <div className="payment-card">
                                    <p className='payment-card-type'>{obj.label}</p>
                                    {/* {obj.labelShort === 'E' && <p className='payment-card-sub-price'>Starting at</p>} */}
                                    {/* <p className={`payment-card-price ${obj.labelShort === 'E' ? 'm-0' : (obj.labelShort === 'C' ? 'mb-46 pt-11' : 'pt-11')}`}>${obj.price}</p> */}
                                    <p className={`payment-card-price ${obj.labelShort === 'C' || obj.labelShort === 'E' ? 'mb-46 pt-11' : 'pt-11'}`}>${obj.price}</p>
                                    {obj.period && <h4 className='account__subhead subhead text-center mb-30'>Per {obj.period}</h4>}
                                    {obj.options.length > 0 && <div className="pb-40">
                                      {obj.options.map((sub, i) => (
                                        <p key={i} className="payment-card-line mt-15">
                                          <i className="mdi mdi-checkbox-blank-circle payment-card-line-icon"></i> {sub.option}
                                          {sub.sidebar .length > 0 && <div><small className="pl-20">{sub.sidebar}</small></div>}
                                        </p>
                                      ))}
                                    </div>}
                                    {obj.key === userPlanId &&
                                      <div className="payment-card-line-button">
                                        <p className="payment-card-line-button-text text-center">Current Plan</p>
                                      </div>}
                                    {/* {userPlanId !== '4' && obj.key === '4' && <div className="mt-30">
                                      <Button
                                        type="button"
                                        color="success"
                                        className="btn btn-hero btn-success account__btn rounded payment-card-line-button">
                                        Downgrade</Button>
                                    </div>} */}
                                    {userPlanId !== '5' && obj.key === '5' && <div className="mt-30">
                                      {/* <Button
                                        color="success"
                                        type="button"
                                        className="btn btn-hero btn-success account__btn rounded payment-card-line-button"
                                        onClick={() => {this.SubmitForm('Professional')}}
                                        >
                                       
                                        Order Now</Button> */}
                                        <button role="link" className="btn btn-hero btn-success account__btn rounded payment-card-line-button" onClick={this.handleClick}>Order Now</button>
                                    </div>}
                                    {userPlanId !== '6' && obj.key === '6' && <div className="mt-30">
                                      <Button
                                        type="button"
                                        color="success"
                                        className="btn btn-hero btn-success account__btn rounded payment-card-line-button"
                                         onClick={() => {this.SubmitForm('Enterprise')}}>

                                        Contact for Quote</Button>
                                    </div>}
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Form>
                      </div>
                    )}
                />
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
};

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  error: state.error,
  SubTest: state.SubTest,
  global: state.global,
  accountInfo: state.accountInfo,
  plan: state.plan,
  VwRUsrSubDtl: state.VwRUsrSubDtl,
   RBtnTracking: state.RBtnTracking,
   RSignUpSurvey: state.RSignUpSurvey,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    // { LoadPage: SubTestReduxObj.LoadPage.bind(SubTestReduxObj) },
    { LoadPage: RBtnTrackingReduxObj.LoadPage.bind(RBtnTrackingReduxObj) },
    { LoadUserPage: VwRUsrSubDtlReduxObj.LoadPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadUserInitPage: VwRUsrSubDtlReduxObj.LoadInitPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadSearchList: VwRUsrSubDtlReduxObj.LoadSearchList.bind(VwRUsrSubDtlReduxObj) },
    // { SavePage: SubTestReduxObj.SavePage.bind(SubTestReduxObj) },
    { SavePage: RBtnTrackingReduxObj.SavePage.bind(RBtnTrackingReduxObj) },
    { DelMst: SubTestReduxObj.DelMst.bind(SubTestReduxObj) },
    { AddMst: SubTestReduxObj.AddMst.bind(SubTestReduxObj) },
    //    { SearchMemberId64: SubTestReduxObj.SearchActions.SearchMemberId64.bind(SubTestReduxObj) },
    //    { SearchCurrencyId64: SubTestReduxObj.SearchActions.SearchCurrencyId64.bind(SubTestReduxObj) },
    //    { SearchCustomerJobId64: SubTestReduxObj.SearchActions.SearchCustomerJobId64.bind(SubTestReduxObj) },
    { SearchsubUsrId2: SubTestReduxObj.SearchActions.SearchsubUsrId2.bind(SubTestReduxObj) },
    { showNotification: showNotification },
    { setTitle: setTitle },
    { setSpinner: setSpinner },
    { setTopbarMenu: setTopbarMenu },
    { hideSidebar: hideSidebar },
    { hideTopbarMenu: hideTopbarMenu },
    { registerTopbarLeft: registerTopbarLeft },
    { registerTopbarCenter: registerTopbarCenter },
    { registerTopbarRight: registerTopbarRight },
    { submitPlan: submitPlan },
    { loadPage: loadPage },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Upgrade);




// WEBPACK FOOTER //
// ./src/pages/Custom/Upgrade.js